import { certificatePageSize } from "../../domain/certificates/certificateTemplates";

/**
 * Put on a panel so every outlined input inside it matches the rest of the
 * dashboard (SearchField, Family): light divider borders, primary on focus.
 */
export const CERTIFICATE_FIELDS_SX = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "divider" },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "primary.main",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "primary.main",
      borderWidth: 1,
    },
  },
} as const;

/** The Templates and Awards tiles on the Certificates page. */
export const CERTIFICATES_TILE_GRID_SX = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
  gap: 2,
} as const;

const { width: CERTIFICATE_WIDTH, height: CERTIFICATE_HEIGHT } = certificatePageSize("landscape");

/**
 * Width for a certificate shown on its own under a page header, narrow enough
 * that the whole certificate and the line under it fit on screen without scrolling.
 */
export const CERTIFICATE_FITS_SCREEN_MAX_WIDTH = {
  xs: "100%",
  sm: `min(960px, calc((100vh - 290px) * ${CERTIFICATE_WIDTH} / ${CERTIFICATE_HEIGHT}))`,
};
